import { Component, ElementRef, inject, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { PageChild } from 'src/app/models/page.interface';
import { environment } from 'src/environments/environment';
import { PathsService } from 'src/app/services/paths/paths.service';
import { LozengeComponent } from '../lozenge/lozenge.component';
import { UilabButton } from '@uilab/base-components-angular';
import { ParseOptions } from 'ngx-dynamic-hooks';

@Component({
    selector: 'app-tabbed',
    templateUrl: './tabbed.component.html',
    styleUrls: ['./tabbed.component.scss'],
    standalone: false,
})
export class TabbedComponent {
    @Input() pages: PageChild[] = [];
    @Input() page: string = '';
    @Input() selectedIndex: number = 0;
    readonly codeOnlyTab = 'code-only-tab';

    public components = [LozengeComponent, UilabButton];
    public options: ParseOptions = {
        sanitize: false,
        convertHTMLEntities: false,
        fixParagraphTags: false,
    };

    private pathsService = inject(PathsService);
    private location = inject(Location);
    private domSanitizer = inject(DomSanitizer);

    selectedIndexChange(event: any): void {
        this.selectedIndex = event;
        const rte = `${environment.base}${this.page}${
            this.pages[this.selectedIndex].slug
        }`;
        this.location.go(rte);
    }

    safeUrl(url: string): any {
        return this.domSanitizer.bypassSecurityTrustResourceUrl(url);
    }

    setAbsoluteImagePaths(content: string): string {
        const spn = document.createElement('span');
        let ele = new ElementRef(spn);
        ele.nativeElement.innerHTML = content;
        ele = this.pathsService.fixDownloadPaths(environment.version, ele);
        ele = this.pathsService.fixImagePaths(ele);

        return ele.nativeElement.outerHTML.toString();
    }

    isCodeExampleTab(page: PageChild): boolean {
        if (!this.isComponentsPage()) {
            return false;
        }

        return (
            page.slug === 'code' ||
            this.normalizeType(page.type) === this.codeOnlyTab
        );
    }

    componentName(): string {
        const segments = this.page.split('/').filter(Boolean);
        const componentsIndex = segments.indexOf('components');

        if (componentsIndex < 0) {
            return '';
        }

        return segments[componentsIndex + 1] ?? '';
    }

    private normalizeType(type: string | undefined): string {
        return (type ?? '').trim().toLowerCase().replaceAll(' ', '-');
    }

    private isComponentsPage(): boolean {
        return this.page.split('/').filter(Boolean).includes('components');
    }
}
